const validate = (values) => {
  const errors = {};

  if (!values.serviceCode || values.serviceCode.trim() === '') {
    errors.serviceCode = 'Please enter service code';
  }
  if (!values.description || values.description.trim() === '') {
    errors.description = 'Please enter description';
  }
  if (!values.ruleID || !Number.isInteger(values.ruleID)) {
    errors.ruleID = 'Please select rounding rule';
  }

  if (!values.unitDuration) {
    errors.unitDuration = 'Please enter unit duration';
  }

  if (!values.unitTypeID || !Number.isInteger(values.unitTypeID)) {
    errors.unitTypeID = 'Please select unit type';
  }
  if (!values.ratePerUnit) {
    errors.ratePerUnit = 'Please enter rate per unit';
  }

  // if (!values.IsBillable) {
  //   if (typeof(values.IsBillable) !== 'boolean') {
  //     errors.IsBillable = 'Please select an option';
  //   }
  // }

  if (values.modifierModel && values.modifierModel.length) {
    const modifierModelArrayErrors = [];
    const modifiersArray = values.modifierModel.map((obj) => obj.modifier);
    values.modifierModel.forEach((modifierObj, modifierIndex) => {
      const modifierErrors = {};
      if (modifierObj && modifierObj.modifier && modifierObj.modifier.trim() === '') {
        let isModifierIndex = (modifiersArray || []).findIndex((obj) => (obj || '').toLowerCase() === (modifierObj.modifier || '').toLowerCase());
        if (isModifierIndex > -1 && isModifierIndex !== modifierIndex) {
          modifierErrors.modifier = 'Please enter another modifier.';
          modifierModelArrayErrors[modifierIndex] = modifierErrors;
        }
        if (!modifierObj.rate) {
          modifierErrors.rate = 'Please enter rate.';
          modifierModelArrayErrors[modifierIndex] = modifierErrors;
        }
      }
      if (modifierObj && modifierObj.rate && !modifierObj.modifier) {
        modifierErrors.modifier = 'Please enter modifier.';
        modifierModelArrayErrors[modifierIndex] = modifierErrors;
      }
      return modifierErrors;
    });
    if (modifierModelArrayErrors.length) {
      errors.modifierModel = modifierModelArrayErrors;
    }
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/serviceCode/components/validate.js